import React from 'react';
import { getActiveIcon } from 'library/helpers';
import { durationString } from 'library/time';
import { formatAvailabilityCycleLegs } from 'selectors/availability.selectors';
import CycleLegFormInput from './input';

const config = {
  // List Table
  list: {
    format: formatAvailabilityCycleLegs,
    // Table Columns
    columns: [
      {
        title: 'Order',
        dataIndex: 'order',
        sorter: true,
        width: '100px',
        align: 'center',
        defaultSortOrder: 'ascend',
        render: (text, record) => record.order
      },
      {
        title: 'Name',
        dataIndex: 'leg__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        render: (text, record) => record.name
      },
      {
        title: 'Duration',
        dataIndex: 'leg__duration',
        sorter: true,
        width: '100px',
        render: (text, record) => durationString(record.duration)
      },
      {
        title: 'Type',
        dataIndex: 'leg__type__name',
        sorter: true,
        width: '100px',
        render: (text, record) => record.type
      },
      {
        title: 'Workable',
        dataIndex: 'leg__type__is_workable',
        width: '200px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Yes',
            value: true
          },
          {
            text: 'No',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.is_workable)
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div>
        <p>
          Are you sure you wish to delete the leg associated with this cycle ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'order',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      leg__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['leg__name'],
        searchValue: ''
      },
      leg__type__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['leg__type__name'],
        searchValue: ''
      }
    },
    // General
    title: 'Legs',
    commands: {
      showDelete: false,
      showAdd: false
    }
  },
  // Detail Screen
  detail: {
    // General
    format: data => data,
    emptyMessage: 'Please select a Record',
    title: 'Leg',
    component: props => (
      <CycleLegFormInput
        {...props}
        title="Leg"
      />
    )
  }
};

export default config;
